export const getStatusColor = (
  status: string
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' => {
  switch (status) {
    case 'new':
      return 'info'
    case 'scheduled':
      return 'primary'
    case 'dispatched':
      return 'warning'
    case 'completed':
      return 'success'
    case 'cancelled':
      return 'error'
    default:
      return 'default'
  }
}

export const getAssignmentStatusColor = (status: string): 'success' | 'error' | 'default' => {
  if (status === 'accepted') return 'success'
  if (status === 'rejected') return 'error'
  return 'default'
}
